import { ForgotPasswordPage } from '@/containers';

export const ForgotPassword = () => {
  return <ForgotPasswordPage />;
};
